export const productConstants = {
  LOADING: "LOADING",
  // Scoped to the products list fetch. The shared LOADING flag is toggled by
  // every other product action too (GetSuppliers, edits, deletes), so it can't
  // drive the products grid placeholder without flickering.
  PRODUCTS_LOADING: "PRODUCTS_LOADING",
  GET_PRODUCT_CATEGORY: "GET_PRODUCT_CATEGORY",
  GET_PRODUCT: "GET_PRODUCT",
  GET_PRODUCT_DETAILED: "GET_PRODUCT_DETAILED",
  GET_ORDERS: "GET_ORDERS",
  REQUEST_ORDER: "REQUEST_ORDER",
  RESPONSE_STATE: "RESPONSE_STATE",
  RESPONSE: "RESPONSE",
  GET_TOTALS: "GET_TOTALS",
  GET_SUPPLIERS: "GET_SUPPLIERS",
  GET_MEMBER_ORDER_HISTORY: "GET_MEMBER_ORDER_HISTORY",
};
